export const validateMentorEmail = (string) => {
    return string.includes('mentor');
}